import { useEffect } from 'react';

import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import useStores from 'shared/hooks/use-stores';
import useApolloClient from 'shared/hooks/use-apollo-client';
import { useCheckout } from 'checkout/context';
import useErnie from 'shared/hooks/use-ernie';
import onCheckoutMount from 'src/checkout/actions/on-checkout-mount';
import { useDutchiePay } from 'src/payments/hooks';
import usePlaidIframeObserver from 'src/payments/hooks/use-plaid-iframe-observer';
import { useDispensaryDisclaimer } from 'src/dispensary/hooks/use-dispensary-disclaimer';

type CheckoutInitResult = {
  order: ReturnType<typeof useStores>['Cart']['order'];
  disclaimerIsBlank: boolean;
  disclaimerTextHtml: string | undefined;
  viewingDeliveryErrorModal: boolean;
};

export default function useCheckoutInit(): CheckoutInitResult {
  const { Cart, User, UI } = useStores();
  const apolloClient = useApolloClient();
  const showErnie = useErnie();
  const CheckoutCtx = useCheckout();
  const { order } = Cart;
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const { isDutchiePayEnabledForDispo, isEnrolledDutchiePay } = useDutchiePay();
  const { disclaimerIsBlank, disclaimerTextHtml } = useDispensaryDisclaimer();

  useEffect(() => {
    void onCheckoutMount({ UI, Cart, User, apolloClient, showErnie, CheckoutCtx });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!User.isLoggedIn) {
      DutchiePayEnrollment.resetEnrollment();
    }
  }, [
    User.isLoggedIn,
    User.email,
    User.id,
    User.profile,
    User.profile.firstName,
    User.profile.lastName,
    User.profile.phone,
    DutchiePayEnrollment,
    isDutchiePayEnabledForDispo,
    isEnrolledDutchiePay,
  ]);

  usePlaidIframeObserver();

  return {
    order,
    disclaimerIsBlank,
    disclaimerTextHtml,
    viewingDeliveryErrorModal: CheckoutCtx.viewingDeliveryErrorModal,
  };
}
